var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04209 7.17081C7.16038 7.92 6.83727 9.28633 7.5986 10.3825C8.31104 11.4082 9.20847 12.3054 10.234 13.0176C11.3301 13.7787 12.6964 13.4555 13.4455 12.5738L13.4539 12.5777C14.4107 13.0209 15.427 13.3247 16.4702 13.4795V15.6484L16.4693 15.6484L16.4669 15.6484C9.91487 15.6577 4.96046 10.6456 4.96747 4.14863V4.14568H7.13602L7.13617 4.14665C7.29101 5.18968 7.59468 6.20511 8.03797 7.16192L8.04209 7.17081ZM16.4693 17.2916H17.2918C17.7456 17.2916 18.1134 16.9238 18.1134 16.47V12.7708C18.1134 12.3637 17.8152 12.0179 17.4124 11.9581L16.7106 11.854C15.823 11.7222 14.9588 11.4638 14.1446 11.0866L13.526 10.8001C13.1676 10.634 12.7417 10.7466 12.5121 11.0681L12.232 11.4601C11.9866 11.8037 11.5181 11.9087 11.1712 11.6678C10.3066 11.0675 9.54888 10.3098 8.94824 9.44506C8.70733 9.09821 8.81228 8.62958 9.15595 8.38416L9.54782 8.10431C9.86933 7.87471 9.98191 7.44878 9.81582 7.09029L9.52897 6.47114C9.15177 5.65697 8.89336 4.79291 8.7616 3.90535L8.6574 3.20342C8.59761 2.80066 8.25185 2.50244 7.84468 2.50244H4.14585C3.69208 2.50244 3.32423 2.87029 3.32423 3.32406V4.14686C3.31624 11.5467 9.00182 17.3022 16.4693 17.2916Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigar);
export default __webpack_public_path__ + "static/media/ligar.ebebfb95770813275c7c4718fec59f7f.svg";
export { ForwardRef as ReactComponent };